<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent && !isEmployerPortal) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Users'"
      [canGoBack]="!windowService.isDesktopRes"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    @if (isEmployerPortal) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-text
            [title]="'Admins'" />
        </div>
      </tidy-desktop-header>
    }

    @if (loaded) {
      <tidy-row [align]="isEmployerPortal ? '' : 'center'">
        @if (isEmployerPortal) {
          <tidy-text
            [body]="'Admins can log into your account with their own credentials. As the account owner, you can revoke access at any time.'" />
        }
        @if (!isEmployerPortal) {
          <tidy-text
            [body]="'Users can log into your account with their own credentials and see the properties you assign to them. As the account owner, you can revoke access at any time.'" />
        }
      </tidy-row>
      <tidy-button
        [action]="boundGoToAddNewUserPage"
        [text]="isEmployerPortal ? 'Add Admin' : 'Add User'"
        class="primary full-width" />
      <div class="desktop-nav-search full-width">
        <form [formGroup]="form" novalidate action="#">
          <tidy-input
            #searchInput
            class="search-input"
            [icon]="'assets/svg/search.svg'"
            [noBorder]="true"
            type="search"
            formControlName="search"
            [label]="'Search'"
            [form]="form" />
        </form>
      </div>
      @for (user of usersList; track user) {
        <tidy-card>
          <tidy-card-button (action)="goToUserPage(user)">
            <tidy-row class="vertical-align-center extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/account.svg'"
                class="header-size" />
              <tidy-text
                [header]="user.first_name + ' ' + user.last_name"
                [translate]="false" />
            </tidy-row>
            @if (clientInfo?.customer_account?.account_type !== 'regular') {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/information-circle-grey.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="getUserType(user?.role)" />
              </tidy-row>
            }
            @if (user?.role !== 'owner' && user?.role !== 'admin') {
              @if (getUserAddresses(user)?.length) {
                <tidy-row class="vertical-align-middle">
                  <tidy-image
                    [src]="'assets/img/location.svg'"
                    class="body-size" />
                  @for (address of getUserAddresses(user); track address; let i = $index) {
                    @if (i == 2 || i == 1) {
                      <tidy-text
                        [body]="', '" />
                    }
                    @if (i == 0 || i == 1 || i == 2) {
                      <tidy-text
                        [body]="address" />
                    }
                    @if (i == 3) {
                      <tidy-text
                        [body]="' +' + getUserAddresses(user)?.length - 3 + (' More' | translate)" />
                    }
                  }
                </tidy-row>
              }
              @if (!user?.team_addresses_permissions?.length) {
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/location.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'No Properties Assigned'" />
                </tidy-row>
              }
            }
          </tidy-card-button>
        </tidy-card>
      }
    }

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

  </tidy-wrapper>
</ng-template>

@if (!isEmployerPortal) {
  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }
  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
}

@if (isEmployerPortal) {
  <app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />
}

